import Tag from '@Components/Tag';
import React, { useEffect, useState } from 'react';
import { PartCategory } from 'types/Categories';
import { CategoriesRow, CategoriesWrpper } from './ProductsWithFilters.styled';

type Props = {
  categories: PartCategory[];
  callback: (val?: number) => void;
  firstLevel?: boolean;
};

export default React.memo(function GlobalFilter({ categories, callback, firstLevel }: Props) {
  const [selectedCategory, setSelectedCategory] = useState<number>();
  const theChildren = categories.find((category) => category.id === selectedCategory)?.children;

  useEffect(() => {
    setSelectedCategory(undefined);
    return () => {
      setSelectedCategory(undefined);
    };
  }, [categories]);

  useEffect(() => {
    if (selectedCategory) {
      if (
        categories.some((cat) => cat.id === selectedCategory) &&
        !Boolean(categories.find((cat) => cat.id === selectedCategory)?.children.length)
      ) {
        callback(selectedCategory);
      } else {
        callback(undefined);
      }
    }
  }, [callback, categories, selectedCategory]);
  return (
    <CategoriesWrpper>
      <CategoriesRow>
        {categories.map((cat) => (
          <Tag
            key={cat.id}
            name={cat.name}
            onClick={() => {
              setSelectedCategory(cat.id);
            }}
            isActive={selectedCategory === cat.id}
            img={firstLevel ? cat.image : undefined}
          />
        ))}
      </CategoriesRow>
      {Boolean(theChildren?.length) && <GlobalFilter categories={theChildren as PartCategory[]} callback={callback} />}
    </CategoriesWrpper>
  );
});
